export * from './MaterialsListItemLightboxTitle.types';
export { default as MaterialsListItemLightboxTitle } from './MaterialsListItemLightboxTitle';
